import React, { Component } from "react";
import TopBar from "../../component/projectDetail/TopBar";
import Banner from "../../component/projectDetail/Banner";
import RightPanel from "../../component/projectDetail/RightPanel";
import * as _ from "lodash";
import { setProjectDetails } from "../../../reducer/showAllReducer";
import { connect } from "react-redux";
import { authService } from "../../../auth";
import alertPopUp from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ProjectAnalyticssection from "./ProjectAnalyticssection";
import "react-datepicker/dist/react-datepicker.css";
import DonationStats from "../../../Donation/DonationStats";
import OrganizationAdmin from "../../../commons/OrganizationAdmin";

const ErorrMsgPopUp = withReactContent(alertPopUp);
class ProjectStatsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            project: props.project,
            projectDetail: {},
            donationConfig: {},
            entityConfig: {},
            showStatsSection: true,
            donorsCount: 0
        }
    }

    componentWillUnmount() {
        window.$('.modal-backdrop').remove();
        ErorrMsgPopUp.clickConfirm();
    }

    componentDidMount() {

    }

    getEntityDonationConfig = (config) => {
        this.setState({
            donationConfig: config
        })
    }

    getDonationConfig = (config) => {
        this.setState({
            entityConfig: config
        })
    }

    hideProjectStatsSection = () => {
        this.setState({
            showStatsSection: false
        })
    }

    getDonorsCount = (count) => {
        this.setState({
            donorsCount: count
        })
    }

    render() {
        return (
            <div className="col-md-9">                
                <div className="projectinn nothidden projdetailscont pdSettingPerms">
                    <Banner {...this.props} getEntityDonationConfig={this.getEntityDonationConfig} needDonationConfig={true} pageType={"STATS_PAGE"} getDonationConfig={this.getDonationConfig} />
                    {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false &&
                        <TopBar {...this.props} />
                    }

                    {this.props.userId && <OrganizationAdmin userId={this.props.userId} />}

                    <div className="projdetlswrap">
                        <div className="row">
                            <div className="col-lg-9">
                                {this.props.projectDetail && !_.isUndefined(this.props.projectDetail.demolished) && this.props.projectDetail.demolished === false && this.props.projectDetail.applicationsTabVisible && this.props.projectDetail.participantTabVisible &&

                                    <div className="projgeneralsec pdapplicationother">

                                        {this.state.showStatsSection &&
                                            <div className="settMngPermsRow">
                                                <ProjectAnalyticssection projectId={this.props.projectDetail.id} projectType={this.props.projectDetail && this.props.projectDetail.project && this.props.projectDetail.project.type} donorsCount={this.state.donorsCount} entityConfig={this.state.entityConfig} hideProjectStatsSection={this.hideProjectStatsSection} />
                                            </div>
                                        }

                                        <DonationStats entityId={this.props.projectDetail.id} entityType={"PROJECT"} entityName={this.props.projectDetail?.project?.title} entitySlug={this.props.projectDetail.slug} donationConfig={this.state.donationConfig} getDonorsCount={this.getDonorsCount} />

                                    </div>
                                }
                            </div>


                            <RightPanel {...this.props} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setProjectDetails: (details) => dispatch(setProjectDetails(details)),
    };
};


export default connect(null, mapDispatchToProps)(ProjectStatsContainer);
